module.exports = __webpack_public_path__ + "img/gjng2900_2.3368d3ea.svg";